export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">About Us</h2>
          <div className="w-24 h-1 bg-[#C9A961] mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20corporate%20business%20team%20meeting%20in%20modern%20luxury%20office%20with%20glass%20walls%20and%20elegant%20interior%20design%20showing%20collaboration%20and%20strategic%20planning%20with%20sophisticated%20ambiance%20and%20premium%20workspace%20environment&width=800&height=600&seq=about-vertak-001&orientation=landscape"
              alt="Vertak Group Team"
              className="w-full h-full rounded-2xl shadow-2xl object-cover"
            />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Who We Are</h3>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              Vertak Group is a multidisciplinary business group based in Jaipur, India, with deep expertise in infrastructure, construction management, mining & minerals, and gems & jewellery markets. We combine industry experience, technical strength, and ethical business practice to deliver sustainable value to clients, partners, and communities.
            </p>
            <p className="text-gray-600 text-base leading-relaxed">
              Our commitment to excellence and innovation has positioned us as a trusted partner across multiple industries, delivering projects that stand the test of time.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-8 rounded-2xl">
            <div className="w-12 h-12 bg-[#C9A961] rounded-lg flex items-center justify-center mb-6">
              <i className="ri-focus-3-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
            <p className="text-gray-600 text-base leading-relaxed">
              To build high-impact infrastructure, unlock natural resource value, and set new standards of quality and professionalism.
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-8 rounded-2xl">
            <div className="w-12 h-12 bg-[#C9A961] rounded-lg flex items-center justify-center mb-6">
              <i className="ri-eye-line text-2xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Vision</h3>
            <p className="text-gray-600 text-base leading-relaxed">
              To be a leading Indian conglomerate recognized for integrity, innovation, and excellence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}